export const SONG_COLLECTIONS = [
  { id: 'psalm-chants', tag: 'psalm-chant', label: 'Psalm Chants', singular: 'Psalm chant' },
  { id: 'circle-songs', tag: 'circle-song', label: 'Circle Songs', singular: 'Circle song' }
] as const;

export type SongCollectionId = typeof SONG_COLLECTIONS[number]['id'];
export const isInCollection = (tags: string[], tag: string) =>
  tags.some(value => value.trim().toLowerCase() === tag);

export interface CollectionFile {
  file_id: number;
  file_type: string;
  filename: string;
  extension: string;
}
export interface CollectionSong {
  song_id: number;
  title: string;
  composer_name: string | null;
  tags: string[];
  versions: {
    version_id: number;
    title: string | null;
    arrangement_type: string | null;
    key_signature: string | null;
    files: CollectionFile[];
  }[];
}
